import { render, staticRenderFns } from "./AddressCategoryForm.vue?vue&type=template&id=b00b3de2&"
import script from "./AddressCategoryForm.vue?vue&type=script&lang=js&"
export * from "./AddressCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports